import { render, staticRenderFns } from "./item_list.vue?vue&type=template&id=7181074e&scoped=true"
import script from "./item_list.vue?vue&type=script&lang=js"
export * from "./item_list.vue?vue&type=script&lang=js"
import style0 from "./item_list.vue?vue&type=style&index=0&id=7181074e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181074e",
  null
  
)

export default component.exports